// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1aSc2","subtitle":"style_subtitle__3ZTNY","item":"style_item__3BM1N"};